import { NgModule } from '@angular/core';
import { NgxScannerQrcodeComponent } from './ngx-scanner-qrcode.component';

@NgModule({
  declarations: [NgxScannerQrcodeComponent],
  exports: [NgxScannerQrcodeComponent]
})
export class NgxScannerQrcodeModule { }
